import { Plus, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Queue } from "@/types/queue";

interface QueueActionsProps {
  queue: Queue;
  onNext: () => void;
  onShowQR: () => void;
}

export const QueueActions = ({ queue, onNext, onShowQR }: QueueActionsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Button 
        onClick={onNext} 
        size="lg" 
        className="w-full sm:w-auto bg-accent hover:bg-accent-hover text-accent-foreground"
      >
        <Plus className="mr-2" size={16} />
        Next in Line
      </Button>
      <Button 
        variant="outline" 
        onClick={onShowQR} 
        size="lg"
        className="w-full sm:w-auto border-muted/30 hover:bg-accent/10 hover:text-accent hover:border-accent"
      >
        <QrCode className="mr-2" size={16} />
        Show QR Code
      </Button>
    </div>
  );
};